module.exports = __webpack_public_path__ + "img/SKMA_rules5.b1ca4148.png";